import error404 from "./error404"
export default error404;
